module.exports.default = "query PopularModels($categoryId:UsedAuto_CategoryId!,$brandId:Int!,$langId:LanguageId,$limit:Int){models(brandId:$brandId,categoryId:$categoryId,langId:$langId,limit:$limit,type:POPULAR){popular{id}}}";
